import React from "react";
import styled, { css } from "styled-components";
import { t } from "../../../core/translate";
import { ocean, jungle } from "@vitalsource/vstui/colors";
import {
  AFFILIATE_URL,
  FREE_SUBSCRIPTION,
  PROMOTION_COVER_HEIGHT
} from "./promotionConsts";

const BADGE_HEIGHT = 28;
const baseBadgeStyles = css`
  align-items: center;
  border-radius: 16px;
  bottom: 15px;
  color: #fff;
  display: flex;
  height: ${BADGE_HEIGHT}px;
  justify-content: center;
  position: absolute;
  top: calc(${PROMOTION_COVER_HEIGHT}px - ${BADGE_HEIGHT / 2}px);
  padding: 0 15px;
  right: 15px;
  min-width: 75px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  z-index: 2;
  pointer-events: none;
`;

const STYLED = {
  FreeBadge: styled.div`
    background: ${ocean.getShade(6)};
    ${baseBadgeStyles}
  `,
  AffiliateBadge: styled.div`
    background: ${jungle.getShade(6)};
    ${baseBadgeStyles}
  `
};

const PromotionBadge = ({ type }) => {
  switch (type) {
    case FREE_SUBSCRIPTION:
      return (
        <STYLED.FreeBadge>
          {t("promotions.free-subscription", "Free")}
        </STYLED.FreeBadge>
      );
    case AFFILIATE_URL:
      return (
        <STYLED.AffiliateBadge>
          {t("promotions.affiliate-offers", "Affiliate Offers")}
        </STYLED.AffiliateBadge>
      );
    default:
      return null;
  }
};

export default PromotionBadge;
